<script setup lang="ts"></script>

<template>
  <div class="apps-qr">
    <div class="apps-qr__text">
      Наведите камеру
      <br />
      на QR-код, чтобы
      <br />
      скачать
    </div>

    <div class="apps-qr__qr-image"></div>
  </div>
</template>

<style scoped lang="scss">
.apps-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 175px;

  &__text {
    margin-bottom: 40px;
    font-size: 16px;
    font-weight: 800;
    line-height: 120%;
  }

  &__qr-image {
    width: 124px;
    height: 124px;
    background-image: url('/assets/images/app-qr.webp');
    background-position: center;
    background-size: contain;
    border-style: none !important;
  }
}
</style>
